import {
  GET_DROP_OR_SWAP,
  GET_DROP_OR_SWAP_DETAIL,
  GET_DROP_OR_SWAP_DETAIL_FAILURE,
  GET_DROP_OR_SWAP_DETAIL_SUCCESS,
  GET_DROP_OR_SWAP_FAILURE,
  GET_DROP_OR_SWAP_SUCCESS,
} from "../constants";

const initialState = {
  loader: false,
  detailLoader: false,
  dropOrSwapData: [],
  dropOrSwapDetailData: [],
  dropOrSwapError: false,
};

export default function ShiftDropOrSwapReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DROP_OR_SWAP:
      state = {
        ...state,
        loader: true,
      };
      break;
    case GET_DROP_OR_SWAP_SUCCESS:
      state = {
        ...state,
        loader: false,
        dropOrSwapData: action.payload,
        dropOrSwapError: false,
      };
      break;
    case GET_DROP_OR_SWAP_FAILURE:
      state = {
        ...state,
        loader: false,
        dropOrSwapData: action.payload ? [] : state.dropOrSwapData,
        dropOrSwapError: !!action.payload,
      };
      break;
    case GET_DROP_OR_SWAP_DETAIL:
      state = {
        ...state,
        detailLoader: true,
      };
      break;
    case GET_DROP_OR_SWAP_DETAIL_SUCCESS:
      state = {
        ...state,
        detailLoader: false,
        dropOrSwapDetailData: action.payload,
      };
      break;
    case GET_DROP_OR_SWAP_DETAIL_FAILURE:
      state = {
        ...state,
        detailLoader: false,
      };
      break;

    default:
      break;
  }
  return state;
}
